import UserInfo from '../../models/UserInfo';

export default {
  namespaced: true,

  state: {
    userInfo: (() => new UserInfo())(),
    token: null,
    isInitedSupportWorkWechat: false,
    // 企业微信是否可用
    isWorkWechatEnabled: false
  },

  getters: {
    userId: state =>
      process.env.VUE_APP_SUPPORT_USER_SYSTEM === 'T'
        ? state.userInfo.userId
        : sessionStorage.getItem('userId')
  },

  mutations: {
    STORE_USER_INFO(state, userInfo) {
      state.userInfo = new UserInfo(userInfo);
    },
    STORE_TOKEN(state, token) {
      state.token = token;
    },
    STORE_IS_INITED_SUPPORT_WORK_WECHAT(state, isInitedSupportWorkWechat) {
      state.isInitedSupportWorkWechat = isInitedSupportWorkWechat;
    },
    STORE_IS_WORK_WECHAT_ENABLED(state, isWorkWechatEnabled) {
      state.isWorkWechatEnabled = isWorkWechatEnabled;
    }
  }
};
